import React, { MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';
import { pathname, forwardUrlParams } from '../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Link from '../../misc/Link';

const useStyles = makeStyles((theme: any) => ({
  signup: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  signupText: {
    color: theme.palette.brand.black,
    marginRight: theme.spacing(0.5),
  },
}));

export default function SignUpLink() {
  const classes = useStyles();
  const history = useHistory();

  function handleClick(e: MouseEvent<HTMLElement>) {
    e.preventDefault();
    history.push({
      pathname: pathname.preLogin.signup.url,
      search: forwardUrlParams(),
    });
  }

  return (
    <div className={classes.signup}>
      <Typography variant="body2" className={classes.signupText}>
        Don't have an account?
      </Typography>
      <Link href="#" onClick={handleClick}>
        <Typography variant="body2" data-automation-id="get-started">
          Get Started
        </Typography>
      </Link>
    </div>
  );
}
